<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="eye icon"></i>
      {{ $t("bulk process detail") }}
    </div>
    <div class="content">
      <div class="description" style="width: 100% !important">
        <table
          class="ui blue very compact celled striped selectable table"
          ref="table"
          style="width:100%"
        >
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("promissory note") }}</th>
              <th>{{ $t("customer") }}</th>
              <th>{{ $t("quota") }}</th>
              <th>{{ $t("message") }}</th>
              <th>{{ $t("status") }}</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { init_ajax_data_datables, enterprise_setup } from "@/utils";
import filters from "@/filters";

export default {
  name: "ShortioLinkModalIndex",
  components: {},
  props: {},
  data() {
    return {
      uuid: "",
      original_url: "",
      shortio_url: "",
      form: undefined,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    show_modal(bulk) {
      let vm = this;

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            if (bulk) {
              let columns = [
                {
                  data: function(row) {
                    return filters.formatDate(
                      row.create_date,
                      vm.enterprise_setup.detailed_date_format,
                    );
                  },
                },
                {
                  data: function(row) {
                    return row.account_number;
                  },
                },
                {
                  data: function(row) {
                    return row.first_name;
                  },
                },
                {
                  data: function(row) {
                    return row.message;
                  },
                },
                {
                  data: function(row) {
                    return filters.formatCurrency(
                      row.quota,
                      vm.enterprise_setup.currency_iso,
                    );
                  },
                },
                {
                  data: function(row) {
                    return row.status_code;
                  },
                },
              ];

              let onSelect = (data) => {
                console.log(data);
                // vm.$refs.instance_modal.show_modal(data);
              };

              let requestTransform = (data) => {
                data.search.bulk_id = bulk.bulk_id;
              };

              let onCreatedRow = () => {};

              vm.datatable = init_ajax_data_datables(
                vm,
                vm.$refs.table,
                window.jQuery.fn.api.settings.api["visalink bulk links url"],
                columns,
                onSelect,
                onCreatedRow,
                requestTransform,
              );
            }
          },
          onHide() {},
        })
        .modal("show");
    },
  },
  mounted() {},
};
</script>
